import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import _template from 'properties/main/table-config.ejs';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class MainTableConfigView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text], input[type=number]' : 'updateAttributes',
            'blur input[type=text], input[type=number]'   : 'lostFocus',
            'focus input[type=text], input[type=number]'   : 'getFocus',
            'change input[type=checkbox]' : 'updateCheckAttributes'
        };

        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldVal = this.model.get(propName);
        this.model.set( propName, propVal );
        this.render();    
        undoService.add({
            undo: () =>{
                this.model.set( propName, oldVal);
                this.render();
            },
            redo:() => {
                this.model.set( propName, propVal);
                this.render();
            }
        }, textConstants.UNDO_MOVE);

    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.checked;
        let oldVal=this.model.get(propName);

        if (propName === 'buttons') {
            if (propVal) {
                propVal = 'bottom';
            } else
            {
                propVal = 'none';
            }
        }
        
        this.model.set( propName, propVal );

        undoService.add({
            undo: () =>{
                this.model.set( propName, oldVal);
                this.render();
            },
            redo:() => {
                this.model.set( propName, propVal);
                this.render();
            }
        }, textConstants.UNDO_MOVE);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let allowColumnResize = util.isTrue(this.model.get('allowColumnResize'));
        $(`input[name='allowColumnResize']`).prop('checked', allowColumnResize );

        let showHeader = util.isTrue(this.model.get('showHeader'));
        $(`input[name='showHeader']`).prop('checked', showHeader );

        let showFooter = util.isTrue(this.model.get('showFooter'));
        $(`input[name='showFooter']`).prop('checked', showFooter );

        let showButtons = this.model.get('buttons') === 'bottom';
        $(`input[name='buttons']`).prop('checked', showButtons );


        this.delegateEvents();
        return this;
    }

}

export default MainTableConfigView;
